/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["details-sidebar{display:block;padding:28px 0}details-sidebar>.header{margin-bottom:20px;padding:0 24px}details-sidebar>.header .title{display:flex;align-items:center}details-sidebar>.header .title .name{font-size:2.1rem;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis}details-sidebar>.header .title file-icon{width:24px;height:24px;margin-right:18px}details-sidebar>.header .close-button{color:rgba(0,0,0,.54);margin-left:auto}details-sidebar .mat-tab-label{min-width:50%}"];
export { styles as styles };
